<template>
  <div>
    <!-- Carrousel SHM -->
    <b-row>
      <b-col cols="6">
        <p class="text-left">Frecuencias naturales procesadas en cada hora</p>
      </b-col>
      <b-col>
        <b-row>
          <b-col class="selSensor text-right">Seleccionar sensor</b-col>
          <b-col>
            <b-form-select
              size="sm"
              id="sensors"
              name="sensors"
              v-model="selectedSensor"
              style="cursor: pointer"
            >
              <b-form-select-option value="null">
                Sensor no seleccionado
              </b-form-select-option>

              <b-form-select-option
                v-for="(sensor, index) in sensorList"
                v-bind:key="index"
                v-bind:value="sensor"
              >
                {{ sensor.description }}
              </b-form-select-option>
            </b-form-select>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row style="min-height: 250px; padding: 10px">
      <b-col
        cols="1"
        class="arrowLeft"
        title="Cambiar a una fecha anterior"
        @click="getPreviousChart"
      >
        <p style="margin-top: 95px; position: absolute">
          <i class="fas fa-chevron-left fa-2x"></i>
        </p>
      </b-col>
      <b-col
        style="
          border-top: 1px solid rgba(0, 0, 0, 0.125);
          border-bottom: 1px solid rgba(0, 0, 0, 0.125);
        "
      >
        <ChartSHM ref="chartSHM" style="padding-left: 30px" />
      </b-col>
      <b-col
        cols="1"
        class="arrowRight"
        title="Cambiar a una fecha posterior"
        @click="getNextChart"
      >
        <p style="margin-top: 95px; position: absolute">
          <i class="fas fa-chevron-right fa-2x"></i>
        </p>
      </b-col>
    </b-row>
    <!-- Carrousel SHM -->

    <!-- Carrousel Historico SHM -->
    <p class="text-left" style="margin-top: 50px">Evolución temporal diaria</p>
    <b-row style="min-height: 350px; padding: 10px">
      <b-col
        style="border: 1px solid rgba(0, 0, 0, 0.125); border-radius: 0.25rem"
      >
        <ChartFreq ref="chartFreq" style="padding-left: 30px" />
      </b-col>
    </b-row>
    <!-- Carrousel Historico SHM -->
  </div>
</template>


<script>
import ChartSHM from "./ChartSHM";
import ChartFreq from "./ChartFreq";

export default {
  data() {
    return {
      selectedSensor: null,
      sensorList: [],
      sensorGroupList: [],
      requestedGroup: null,
      position: 0, //cargar última gráfica por defecto
    };
  },
  watch: {
    selectedSensor: function (newVal, oldVal) {
      // Recargar gráfica cambiando de sensor y manteniendo la posicion
      this.selectedSensor = newVal;
      return this.loadChartData(newVal, this.position)
    },
  },   
  components: {
    ChartSHM,
    ChartFreq,
  },
  methods: {
    // Al cargar el formulario se carga la gráfica 0 que
    // corresponde a la posición 0 del array, se irá
    // aumentando o dismininuyendo la posición en función de la solicitud del usuario
    async requestChartLoad(groupData, pos) {
      this.sensorGroupList = groupData.sensor;
      this.requestedGroup = groupData;
      await this.populateSelector(groupData)
      await this.loadChartData(this.selectedSensor, pos)
    },


   //Cambiar datos en función de lo seleccionado
    loadChartData(sensorData, pos) {
      this.$refs.chartSHM.retrieveChartSHM(sensorData._id, pos);
      this.$refs.chartFreq.createChartFreq(sensorData._id);
    },


    //Llenar el listado del desplegable, metemos el objeto completo para tenerlo todo identificado
    //Solo llenamos el array con los elementos SHM
    async populateSelector(groupData) {
      this.sensorList = [];
      for await (let sensor of groupData.sensor)
        if(sensor.isShm){
            this.sensorList.push(sensor)
        }
      // Seleccionar un elemento como primario para desplegarlo
      this.selectedSensor = this.sensorList[0]
    },    

    //Pedir la siguiente terna de datos
    getNextChart() {
      this.position++;
      this.$refs.chartSHM.retrieveChartSHM(
        this.selectedSensor._id,
        this.position
      );
    },

    //Pedir la terna anterior de datos
    getPreviousChart() {
      if (this.position <= 0) {
        this.position = 0;
      } else {
        this.position--;
      }
      this.$refs.chartSHM.retrieveChartSHM(
        this.selectedSensor._id,
        this.position
      );
    },
  },
};
</script>

<style scoped>
.list-group-item {
  border: 0px !important;
  padding: 5px 5px 5px 60px !important;
}

.arrowLeft {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem 0rem 0rem 0.25rem;
  cursor: pointer;
  max-width: 50px !important;
  padding: 0px 0px 0px 15px !important;
  background-color: rgb(243, 242, 242);
}

.arrowLeft:hover {
  background-color: rgb(236, 235, 235);
}

.arrowRight {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0rem 0.25rem 0.25rem 0rem;
  cursor: pointer;
  max-width: 50px !important;
  padding: 0px 0px 0px 15px !important;
  background-color: rgb(243, 242, 242);
}

.arrowRight:hover {
  background-color: rgb(236, 235, 235);
}

.tituloAlt {
  font-size: 0.95rem;
  color: #606266;
  font-weight: 400;
}

.selSensor {
  padding: 3px;
  font-size: 0.95rem;
  color: #606266;
  font-weight: 400;
}
</style>